import type { ReactNode } from 'react';
import { ThemeProvider } from '../contexts/ThemeContext';
import NativeAppearance from '../native/NativeAppearance';
import ErrorBoundary from './ErrorBoundary';

/** Keep appearance listeners alive while app content displays recovery. */
export default function AppAppearance({ children }: { children: ReactNode }) {
  return <ErrorBoundary>
    <ThemeProvider>
      <NativeAppearance />
      <ErrorBoundary>{children}</ErrorBoundary>
    </ThemeProvider>
  </ErrorBoundary>;
}
